<template>
  <div class="bg">
    <a-row>
      <a-col :span="6">
        <a-row class="item" style="padding-left: 200px">
          <a-col :span="8">
            <router-link to="/"><span class="title_bg">系统首页</span></router-link>
          </a-col>
          <a-col :span="6"></a-col>
          <a-col :span="8">
            <router-link to="/jizhan"><span class="title_bg">基站列表</span></router-link>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="12"> </a-col>
      <a-col :span="6">
        <a-row class="item">
          <a-col :span="8">
            <router-link to="/shezhi"><span class="title_bg">系统设置</span></router-link>
          </a-col>
          <a-col :span="1"></a-col>
          <!-- <a-col :span="5">权限管理</a-col> -->
          <a-col :span="15" @click="logout"><span class="title_bg">退出登录</span>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { onMounted } from "vue";
import { useRouter } from "vue-router";
export default {
  name: "HeadPage",
  components: {},
  props: {},
  setup() {
    const store = useStore();
    const $router = useRouter();
    const logout = () => {
      store.dispatch("logout");
      $router.push("/login");
    };

    onMounted(() => {
      //组件挂载时的生命周期执行的方法
    });
    return {
      logout,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title {
  height: 86px;
  line-height: 83px;
  width: 100%;
  display: block;
  text-align: center;
  color: #a5e3ed;
  font-family: "YSBTH";
  font-size: 42px;
}

.logout {
  cursor: pointer;
}

.bg {
  background: url("@/assets/head3.png");
  background-size: 100% auto;
  width: 100%;
  height: 110px;
}

.title_bg {
  background: url("@/assets/anbg.png");
  width: 160px;
  height: 48px;
  text-align: center;
  line-height: 48px;
  display: block;
  margin-top: 60px;
}

.ant-col {
  text-align: center;
}

.item {
  color: #bcc4ce;
  height: 83px;
  line-height: 83px;
  font-size: 20px;
  font-weight: bold;
}

.item a {
  color: #fff;
}
</style>
